import { IMediaItem } from 'types/media'
import { ZOrderAction } from '../types'

export interface IZIndexUpdate {
  id: string
  zIndex: number
}

const groupByZIndex = (mediaItems: IMediaItem[]) => {
  const sortedDesc = [...mediaItems].sort((a, b) => b.zIndex - a.zIndex)
  const hashMap = new Map<number, IMediaItem[]>()

  for (const item of sortedDesc) {
    const list = hashMap.get(item.zIndex) ?? []
    list.push(item)
    hashMap.set(item.zIndex, list)
  }

  return hashMap
}

export const getZIndexUpdatesForAction = (
  mediaItems: IMediaItem[],
  itemId: string,
  action: ZOrderAction
): IZIndexUpdate[] | null => {
  const item = mediaItems.find(m => m.id === itemId)
  if (!item || mediaItems.length === 0) return null

  const sorted = [...mediaItems].sort((a, b) => a.zIndex - b.zIndex)
  const currentIdx = sorted.findIndex(m => m.id === itemId)

  const zIndexMap = groupByZIndex(mediaItems)
  /// function

  switch (action) {
    case ZOrderAction.BringToFront: {
      if (currentIdx === sorted.length - 1) return null
      return [{ id: itemId, zIndex: sorted[sorted.length - 1].zIndex + 1 }]
    }
    case ZOrderAction.BringToBack: {
      if (currentIdx === 0) return null
      return [{ id: itemId, zIndex: sorted[0].zIndex - 1 }]
    }
    case ZOrderAction.BringForward: {
      const mapKeys = [...zIndexMap.keys()]
      const currentKeyIdx = mapKeys.indexOf(item.zIndex)
      if (currentKeyIdx <= 0) return null

      const prevKey = mapKeys[currentKeyIdx - 1]
      const targetZIndex = prevKey + 1

      const updates: IZIndexUpdate[] = [{ id: itemId, zIndex: targetZIndex }]

      let floor = targetZIndex
      for (let i = currentKeyIdx - 2; i >= 0; i--) {
        const key = mapKeys[i]
        if (key > floor) break
        const shiftedKey = floor + 1
        for (const other of zIndexMap.get(key) ?? []) {
          updates.push({ id: other.id, zIndex: shiftedKey })
        }
        floor = shiftedKey
      }

      return updates
    }
    case ZOrderAction.BringBackward: {
      const mapKeys = [...zIndexMap.keys()]
      const currentKeyIdx = mapKeys.indexOf(item.zIndex)
      if (currentKeyIdx === -1 || currentKeyIdx === mapKeys.length - 1)
        return null

      const nextKey = mapKeys[currentKeyIdx + 1]
      const targetZIndex = nextKey - 1

      const updates: IZIndexUpdate[] = [{ id: itemId, zIndex: targetZIndex }]

      let ceiling = targetZIndex
      for (let i = currentKeyIdx + 2; i < mapKeys.length; i++) {
        const key = mapKeys[i]
        if (key < ceiling) break
        const shiftedKey = ceiling - 1
        for (const other of zIndexMap.get(key) ?? []) {
          updates.push({ id: other.id, zIndex: shiftedKey })
        }
        ceiling = shiftedKey
      }

      return updates
    }
  }
}
